import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCog,
  faEdit,
  faKey,
  faPlus,
  faRedo,
  faSearch,
  faSignOutAlt,
  faThList,
  faUser,
  faUserCog,
  faSort,
  faSortUp,
  faSortDown,
  faInfoCircle,
  faTrashAlt,
  faCommentDots,
  faComments,
  faLock,
  faLockOpen,
  faReply,
  faThumbtack,
  faStickyNote,
  faUserCircle,
  faEnvelope,
  faPaperPlane,
  faSave,
  faTimes,
  faChartLine,
  faCompass,
  faImage,
  faKeyboard,
} from '@fortawesome/free-solid-svg-icons';

// 仕様するiconをlibraryに追加しておく
library.add(
  faCog,
  faEdit,
  faKey,
  faPlus,
  faRedo,
  faSearch,
  faSignOutAlt,
  faThList,
  faUser,
  faUserCog,
  faSort,
  faSortUp,
  faSortDown,
  faInfoCircle,
  faTrashAlt,
  faCommentDots,
  faComments,
  faLock,
  faLockOpen,
  faReply,
  faThumbtack,
  faStickyNote,
  faUserCircle,
  faEnvelope,
  faPaperPlane,
  faSave,
  faTimes,
  faChartLine,
  faCompass,
  faImage,
  faKeyboard,
);
